import type { TranslateResult } from "vue-i18n";

export function withConfirmationDialog({
  title,
  subtitle,
  onCancel,
  onConfirm,
}: {
  title: TranslateResult;
  subtitle?: TranslateResult;
  onConfirm?: () => void;
  onCancel?: () => void;
}) {
  return useDialog("ConfirmationDialog").open(
    {
      title,
      subtitle,
    },
    {
      onConfirm,
      onCancel,
    },
  );
}
